import { createStore, applyMiddleware, compose } from 'redux';
import fetchMiddleware from './middlewares/fetchMiddleware';
import reducers from './modules';

const middlewares = [
  fetchMiddleware,
];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function buildStore(initialState) {
  const store = createStore(
    reducers,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );
  // So we can access the store from the global scope
  // useful for the native app to repaint the view.
  window.store = store;
  return store;
}